var map = {
	"./5stars.png": "71cc",
	"./Amanda.png": "0ab8",
	"./awards.png": "30fe",
	"./erji.png": "cbcf",
	"./kedit.png": "7b9c",
	"./logo.png": "7b3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e3f";